import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ServerMessage } from '../_models/server.message';
import { environment } from 'environments/environment';
import { AuthenticationService, StorageService } from '../_services';
import { decrypt } from '../_services/security.service';

@Injectable({
  providedIn: 'root'
})
export class DocusignService {

  //Prod
  // private urlDocManager = process.env.DOC_MANAGER_LAMBDA_PROD;
  // private urlDocusign = process.env.DOCUSIGN_LAMDBA_PROD;

  //Staging
  private urlDocManager = environment.DOC_MANAGER_LAMBDA_PROD;
  private urlDocusign = environment.DOCUSIGN_LAMDBA_PROD;
  private subdomain: string = location.host.split('.')[0];

  // logginAccessKey: any;
  // currentUser: any;

  //Encrypt mode
  private encryptData = environment.encryptData;

  constructor(
    private http: HttpClient,
    private storageService: StorageService,
    private authenticationService: AuthenticationService,

  ) {
    // this.currentUser = this.storageService.getItem('SignIn');
    // this.logginAccessKey = this.currentUser ? this.currentUser?.LoginSessionKey : '';
  }

  async signDocument(req): Promise<any> {
    let reqObj = {
      mode: "embed-ui",
      signerEmail: req.signerEmail,
      signerName: req.signerName,
      ccEmail: req.ccEmail,
      documentUrl: req.documentUrl,
      redirectUrl: req.redirectUrl,
      dealId: req.dealId,
      userId: req.userId,
      path: req.path,
      name: req.name,
      entityType: req.entityType,
      logginAccessKey: this.authenticationService.currentUserValue.LoginSessionKey,
      kintoken: localStorage.getItem('docManagerToken'),
      emulate: this.subdomain == 'cp' ? true : false
    }

    // if (req.userId) {
    //     reqObj['userId'] = req.entityUserId;
    // }

    try {
      return new Promise((resolve) => {
        // const formData = new FormData()
        // formData.append(req);

        // Headers
        const headers = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
          })
        };

        this.http.post(this.urlDocusign,
          reqObj,
          headers)
          .subscribe({
            next: (resp) => {
              resolve(resp["message"]);
            },
            error: (error) => {
              resolve(error);
            }
          });
      })
    } catch (err) {
      console.error(err);
    }
  }

  async getDocument(req): Promise<any> {

    req["mode"] = "review-document";
    req["logginAccessKey"] = this.authenticationService.currentUserValue.LoginSessionKey;
    req["kintoken"] = localStorage.getItem('docManagerToken');
    req["userId"] = this.authenticationService.currentUserValue.UserDetails.UserID;
    req["emulate"] = this.subdomain == 'cp' ? true : false;

    // let reqObj = {
    //     mode: "review-document",
    //     envelopeId: req.envelopeId,
    //     documentId: req.documentId
    // };
    try {
      return new Promise((resolve) => {
        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            // "Access-Control-Allow-Headers":
            //   "Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token",
            // "Access-Control-Allow-Origin": "*"
            // "Access-Control-Allow-Methods":
            //   "DELETE,GET,HEAD,OPTIONS,PATCH,POST,PUT"
          })
        };

        this.http
          .post(
            this.urlDocusign,
            req,
            headers
          )
          .subscribe({
            next: (resp) => {
              resolve(resp);
            },
            error: (error) => {
              resolve(error);
            }
          });
      });
    } catch (err) {
      console.error(err);
    }
  }

  async listSignature(req): Promise<any> {

    req["mode"] = "list-signature";
    req["logginAccessKey"] = this.authenticationService.currentUserValue.LoginSessionKey

    // let reqObj = {
    //     mode: "review-document",
    //     envelopeId: req.envelopeId,
    //     documentId: req.documentId
    // };
    try {
      return new Promise((resolve) => {
        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            'kintoken': localStorage.getItem('docManagerToken')
          })
        };

        this.http
          .post(
            this.urlDocManager,
            req,
            headers
          )
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      });
    } catch (err) {
      console.error(err);
    }
  }

  async requestSignature(req): Promise<any> {

    req["mode"] = "request-signature";
    req["logginAccessKey"] = this.authenticationService.currentUserValue.LoginSessionKey

    // let reqObj = {
    //     mode: "review-document",
    //     envelopeId: req.envelopeId,
    //     documentId: req.documentId
    // };
    try {
      return new Promise((resolve) => {
        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            'kintoken': localStorage.getItem('docManagerToken')
          })
        };

        this.http
          .post(
            this.urlDocManager,
            req,
            headers
          )
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      });
    } catch (err) {
      console.error(err);
    }
  }

  async updateSignature(req): Promise<any> {

    req["mode"] = "update-signature";
    req["logginAccessKey"] = this.authenticationService.currentUserValue.LoginSessionKey

    try {
      return new Promise((resolve) => {
        // Headers
        const headers = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "kintoken": localStorage.getItem('docManagerToken')
          })
        };

        this.http
          .post(
            this.urlDocManager,
            req,
            headers
          )
          .subscribe({
            next: (resp: any) => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(resp['message']));
              } else {
                result = resp;
              }
              resolve(result['message']);
            },
            error: error => {
              let result;
              if (this.encryptData) {
                result = JSON.parse(decrypt(error['message']));
              } else {
                result = error;
              }
              resolve({ error: true, statusCode: result['statusCode'] });
            }
          });
      });
    } catch (err) {
      console.error(err);
    }
  }
}